<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsEtnia"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsEtnia"
          addFilter
          :items="listarEtnia"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editEtnia"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="etnia.id === 0 ? addEtnia() : editandoEtnia()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="etnia.descricao">Descrição</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Etnia',
      titleModal: '',
      titlePDF: 'Etnia',
      listarEtnia: [],
      baseUrlGestaoProjetosConcurso: '',
      etnia: [],
      itemPorPage: '100',
      actionsEtnia: [
        {
          button: true,
          funcaoButton: 'editEtnia',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteEtnia',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsEtnia: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoEtnia: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'CategoriaEtnicoRacial/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarEtnia = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar etnia'
      this.etnia = {}
      this.etnia.id = 0
      this.$root.$emit('bv::show::modal', 'editEtnia')
    },
    editEtnia: function (_, item) {
      this.titleModal = 'Editar etnia'
      this.etnia = item
      this.$root.$emit('bv::show::modal', 'editEtnia')
    },
    editandoEtnia: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'CategoriaEtnicoRacial/Alterar',
          this.etnia,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.etnia = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEtnia')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addEtnia: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'CategoriaEtnicoRacial/Adicionar',
          this.etnia,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.etnia = {}
          this.listandoEtnia()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEtnia')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteEtnia: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'CategoriaEtnicoRacial/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoEtnia()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoEtnia()
  }
}
</script>
